import  SponsorCard  from "../SponsorCard/SponsorCard"
import SideCard  from "../SideCard/SideCard"
import  MemberList  from "../MemberList/MemberList"
import GeneralSponsorCard from "../GeneralSponsorCard/GeneralSponsorCard"
import MedilinkInfoCard from "../MedilinkInfoCard/MedilinkInfoCard" // Import the new component
import InviteFriendsSection from "../InviteFriendsSection/InviteFriendsSection" // Import the new component
import AccessDoctorsCard from "../AccessDoctorsCard/AccessDoctorsCard"

import "./Sidebar.css"

export default function Sidebar() {
  return (
    <div className="sidebar">
   
      <SponsorCard />
      <AccessDoctorsCard />
      <InviteFriendsSection />
      <MemberList />
 
      <MedilinkInfoCard /> {/* Add the new Medilink info card here */}
    </div>
  )
}
